/*
 * @Author: qian.tang
 * @Date: 2023-09-21 10:30:26
 * @LastEditors: Qian Tang qian@itrazotracetech.com
 * @LastEditTime: 2023-10-25 14:00:08
 * @FilePath: \itrazo-portal-dev\src\containers\Pages\AssetManagement\apis\CustomerAPI.tsx
 * @Description: 
 * 
 * Copyright (c) 2023 by ${git_name_email}, All Rights Reserved. 
 */
import { ASSET_MANAGEMENT_API as AM_API, CRM_API } from "utilities/AdiApi";
import { logError } from '../../RelationshipManagement/utilities/functions'
import { getBizCode } from "utilities/Functions/GlobalHelperFunctions";

const CRM_CustomerAPI = {

  getAllCustomer: async () => {
    try {
      const url = `${getBizCode()}/Customer`
      const res = await CRM_API.get(url)
      console.log('getAll res', res)
      return res.data.Items
    } catch (e) {
      logError(e)
      console.log('getAll cate fail...', e)
      throw e
    }
  },

}

export default CRM_CustomerAPI